import { render, staticRenderFns } from "./AmountCYInputNoNamePage.vue?vue&type=template&id=5a1fce3b&scoped=true"
import script from "./AmountCYInputNoNamePage.vue?vue&type=script&lang=js"
export * from "./AmountCYInputNoNamePage.vue?vue&type=script&lang=js"
import style0 from "./AmountCYInputNoNamePage.vue?vue&type=style&index=0&id=5a1fce3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1fce3b",
  null
  
)

export default component.exports